export default {
    reportList: "/api/report/html/list", // 报告列表查询接口
    reportUpload: '/api/report/html/upload', // 报告上传接口
    reportPdf: '/api/report/html/report/info', // 报告pdf
    picUrlList: '/api/report/html/pic/report/info',// 报告图片列表
};
  